import { hasRole } from '../utils/check-permission';
import { isPreviewEnabled, OPT_IN_MODULE_FLAGS } from '../config/company-modules';

const enabled = (user, companyId) => isPreviewEnabled(user?.data?.companies?.[companyId], OPT_IN_MODULE_FLAGS.AUTO);

// Presentation only: the API also hides companies without feature_auto.
export const autoAvailable = (user, roles = ['Azienda', 'Studio', 'Operatore'], companyId = user?.data?.current_company) => {
  if (!hasRole(user, roles)) return false;
  if (Number(companyId)) return enabled(user, companyId);
  return Object.keys(user?.data?.companies ?? {}).some((id) => enabled(user, id));
};
